// extracted by mini-css-extract-plugin
export default {"page":"LandingPage_page__yn18j","layout":"LandingPage_layout__wL0ly"};